import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=425f17e7&"
import script from "./Language.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Language.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports